import { Utils } from "@/plugins/utils"

const baseUrl = "/OryxPdv/Establishment"

export default {
	namespaced: true,
	state: {
		est: null,
		lstEst: [],
		hasNext: false,
		search: "",
		insert: false,
		itemsPerPage: 20,
		loading: false,
		update: false,
	},
	getters: {
		getLstEst: state => state.lstEst,
		getLoading: state => state.loading,
		getSearch: state => {
			return {
				search: state.search,
				limit: state.itemsPerPage,
				page: 1,
			}
		},
		getEst: state => state.est,
		getItemsPerPage: state => state.itemsPerPage,
		getHasNext: state => state.hasNext,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
	},
	mutations: {
		cleanStore(state) {
			state.est = null
			state.lstEst = []
			state.insert = false
			state.update = false
		},
		setEst(state, est) {
			state.est = est
		},
		setLstEst(state, lstEst) {
			state.lstEst = lstEst
		},
		setGridParams(state, payload) {
			state.lstEst = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, payload) {
			state.loading = payload
		},
		setEstId(state, estid) {
			state.est.estid = estid
		},
		setSearch(state, payload) {
			state.search = payload
		},
		setInsert(state, payload) {
			state.insert = payload
		},
		setUpdate(state, payload) {
			state.update = payload
		},
	},
	actions: {
		initForm({ commit }) {
			commit("cleanStore")
		},
		setLoading({ commit }, payload) {
			commit("setLoading", payload)
		},
		setUpdate({ commit }, payload) {
			commit("setUpdate", payload)
			commit("setInsert", !payload)
		},
		setInsert({ commit }, payload) {
			commit("setInsert", payload)
			commit("setUpdate", !payload)
		},

		async save({ dispatch, getters }) {
			let est = getters.getEst
			if (est.estsenha === "*********") {
				est.estsenha = ""
			}
			if (est.estusuario === "*********") {
				est.estusuario = ""
			}
			if (getters.getUpdate) {
				return await dispatch("update", est)
			}
			return await dispatch("insert", est)
		},
		async find({ commit, dispatch }, { estid, estcliente }) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get(`${baseUrl}/Find/${estid}/${estcliente}`)
				.then(response => {
					let est = Utils.ValidateAxiosResponse(response.data)
					commit("setEst", est)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async findAllByMatriz({ commit, dispatch }, estid) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get(`${baseUrl}/FindAllByMatriz/${estid}`)
				.then(response => {
					let lstEst = Utils.ValidateAxiosResponse(response.data)
					return lstEst
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async insert({ commit, dispatch }, est) {
			commit("setLoading", true)
			let estId = await this._vm.$axios
				.post(`${baseUrl}/Insert`, est)
				.then(response => {
					commit("setEstId", Utils.ValidateAxiosResponse(response.data))
					return response.data
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return estId
		},
		async update({ commit, dispatch }, est) {
			commit("setLoading", true)
			let estid = await this._vm.$axios
				.put(`${baseUrl}/Update`, est)
				.then(response => {
					commit("setEstId", Utils.ValidateAxiosResponse(response.data))
					return response.data
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return estid
		},
		async delete({ commit, dispatch }, { estid, estcliente }) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.delete(`${baseUrl}/Delete/${estid}/${estcliente}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async search({ commit, dispatch, getters }) {
			commit("setLoading", true)
			let { search, limit, page } = getters.getSearch
			await this._vm.$axios
				.get(`${baseUrl}/Search?search=${search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setGridParams", payload)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		findForStockControll({ commit, dispatch }, estid) {
			commit("setLoading", true)
			return this._vm.$axios
				.get(`${baseUrl}/FindForStockControll/${estid}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					return payload
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
	},
}
